import { render, staticRenderFns } from "./SupplyList.vue?vue&type=template&id=79a792d5&scoped=true"
import script from "./SupplyList.vue?vue&type=script&lang=js"
export * from "./SupplyList.vue?vue&type=script&lang=js"
import style0 from "./SupplyList.vue?vue&type=style&index=0&id=79a792d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a792d5",
  null
  
)

export default component.exports